import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "edit-header" }
const _hoisted_3 = { class: "edit-header-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "flex-center py-10"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_11 = { class: "edit-grid" }
const _hoisted_12 = { class: "edit-main" }
const _hoisted_13 = { class: "widget edit-card" }
const _hoisted_14 = { class: "form-field-floating lg reactive active" }
const _hoisted_15 = {
  key: 0,
  class: "text-red"
}
const _hoisted_16 = { class: "edit-row" }
const _hoisted_17 = { class: "form-field-floating lg reactive active" }
const _hoisted_18 = {
  key: 0,
  class: "text-red"
}
const _hoisted_19 = { class: "form-field-floating active" }
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "text-red"
}
const _hoisted_22 = { class: "form-field-floating lg reactive" }
const _hoisted_23 = {
  key: 1,
  class: "text-red"
}
const _hoisted_24 = { class: "edit-row" }
const _hoisted_25 = {
  key: 0,
  class: "text-red"
}
const _hoisted_26 = { class: "form-field-floating lg reactive" }
const _hoisted_27 = {
  key: 0,
  class: "text-red"
}
const _hoisted_28 = { class: "form-field-floating lg reactive" }
const _hoisted_29 = {
  key: 2,
  class: "text-red"
}
const _hoisted_30 = { class: "widget edit-card" }
const _hoisted_31 = { class: "secteurs-grid" }
const _hoisted_32 = ["for"]
const _hoisted_33 = ["id", "value"]
const _hoisted_34 = {
  key: 0,
  class: "text-red"
}
const _hoisted_35 = { class: "edit-side" }
const _hoisted_36 = { class: "widget edit-card" }
const _hoisted_37 = { class: "logo-uploader" }
const _hoisted_38 = { class: "logo-preview" }
const _hoisted_39 = ["src"]
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  key: 2,
  class: "logo-placeholder"
}
const _hoisted_42 = { class: "logo-actions" }
const _hoisted_43 = {
  for: "logo-input",
  class: "btn white2 active",
  style: {"cursor":"pointer"}
}
const _hoisted_44 = { class: "edit-footer-actions" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }

import { inject, onMounted, reactive, ref } from 'vue';
    import axios from 'axios';
    import { useRouter } from 'vue-router';
    import moment from 'moment';
    import CustomPhoneInput from '@/components/CustomPhoneInput.vue';
    import { showAlert } from '@/utils/swal';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MaCollectiviteEdit',
  setup(__props) {

    const router = useRouter();
    const BACKEND_URL = inject('BACKEND_URL');
    const errorMessage = ref('');
    const loading = ref(false);
    const pageLoading = ref(true);

    const logoFile = ref<File | null>(null);
    const logoPreview = ref<string | null>(null);
    const existingLogo = ref<string | null>(null);

    const startupFormDatas = reactive({
        pays: [] as any[],
    });

    const formData = reactive({
        id: null as number | null,
        nom: '',
        rccm: '',
        adresse: '',
        telephone: '',
        email: '',
        date_creation: '',
        pays_id: null as number | null,
        secteurs: [] as string[],
    });

    const errors = reactive({
        nom: '',
        rccm: '',
        adresse: '',
        telephone: '',
        email: '',
        date_creation: '',
        pays_id: '',
        secteurs: '',
    });

    const secteurs = [
        { id: 'finance', value: 'Finance', label: 'Finance' },
        { id: 'informatique', value: 'Informatique', label: 'Informatique' },
        { id: 'agriculture', value: 'Agriculture', label: 'Agriculture' },
        { id: 'education', value: 'Éducation', label: 'Éducation' },
        { id: 'sante', value: 'Santé', label: 'Santé' },
        { id: 'transport', value: 'Transport', label: 'Transport' },
        { id: 'construction', value: 'Construction', label: 'Construction' },
        { id: 'commerce', value: 'Commerce', label: 'Commerce' },
        { id: 'industrie', value: 'Industrie', label: 'Industrie' },
        { id: 'autre', value: 'Autre', label: 'Autre' },
    ];

    function normalizeSecteurs(raw: any): string[] {
        if (!Array.isArray(raw)) return [];
        const canonical = new Map(secteurs.map(s => [s.value.toLowerCase(), s.value]));
        return raw.map((v: any) => {
            const key = String(v).toLowerCase();
            return canonical.get(key) ?? String(v);
        });
    }

    onMounted(async () => {
        try {
            const response = await axios.get('/collectivites/ma-collectivite/form_datas');
            const { collectivite, startupFormDatas: startup } = response.data;
            Object.assign(startupFormDatas, startup);
            if (collectivite) {
                if (collectivite.date_creation) {
                    const date = moment(collectivite.date_creation);
                    collectivite.date_creation = date.isValid() ? date.format('YYYY-MM-DD') : '';
                }
                Object.assign(formData, collectivite);
                formData.secteurs = normalizeSecteurs(collectivite.secteurs);
                existingLogo.value = collectivite.logo || null;
            }
        } catch (e: any) {
            errorMessage.value = e.response?.data?.message || 'Impossible de charger la collectivité';
        } finally {
            pageLoading.value = false;
        }
    });

    function onLogoSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) return;
        logoFile.value = file;
        const reader = new FileReader();
        reader.onload = (e) => { logoPreview.value = e.target?.result as string; };
        reader.readAsDataURL(file);
    }

    function clearLogo() {
        logoFile.value = null;
        logoPreview.value = null;
    }

    function validate() {
        let isValid = true;

        errors.nom = '';
        if (!formData.nom) { errors.nom = 'Le nom est requis'; isValid = false; }

        errors.pays_id = '';
        if (!formData.pays_id || formData.pays_id <= 0) { errors.pays_id = 'Le pays est requis'; isValid = false; }

        errors.rccm = '';
        if (!formData.rccm) { errors.rccm = 'Le RCCM est requis'; isValid = false; }

        errors.adresse = '';
        if (!formData.adresse) { errors.adresse = "L'adresse est requise"; isValid = false; }

        errors.telephone = '';
        if (!formData.telephone) { errors.telephone = 'Le téléphone est requis'; isValid = false; }

        errors.email = '';
        if (!formData.email) {
            errors.email = "L'email est requis";
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Le format de l'email est invalide";
            isValid = false;
        }

        errors.secteurs = '';
        if (!formData.secteurs || formData.secteurs.length === 0) {
            errors.secteurs = 'Au moins un secteur est requis';
            isValid = false;
        }

        errors.date_creation = '';
        if (!formData.date_creation) { errors.date_creation = 'La date de création est requise'; isValid = false; }

        return isValid;
    }

    async function onSubmit() {
        if (!validate()) return;
        loading.value = true;
        errorMessage.value = '';
        try {
            const payload = new FormData();
            payload.append('nom', formData.nom);
            payload.append('rccm', formData.rccm);
            payload.append('adresse', formData.adresse);
            payload.append('telephone', formData.telephone);
            payload.append('email', formData.email);
            payload.append('date_creation', formData.date_creation);
            payload.append('pays_id', String(formData.pays_id ?? ''));
            formData.secteurs.forEach((s, i) => payload.append(`secteurs[${i}]`, s));
            if (logoFile.value) {
                payload.append('logo', logoFile.value);
            }

            await axios.post('/collectivites/ma-collectivite/update', payload, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            showAlert.success('Collectivité mise à jour avec succès');
            router.push('/front/collectivites/ma-collectivite');
        } catch (error: any) {
            errorMessage.value = error.response?.data?.message || error.message || 'Une erreur est survenue';
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    function onCancel() {
        router.push('/front/collectivites/ma-collectivite');
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "edit-header-left" }, [
        _createElementVNode("button", {
          type: "button",
          class: "btn white2",
          onClick: onCancel
        }, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("img", {
            src: "/public/icons/icon-back.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Retour", -1)
        ]))]),
        _cache[9] || (_cache[9] = _createElementVNode("div", null, [
          _createElementVNode("p", {
            class: "text-sm text-grey-500",
            style: {"margin":"0"}
          }, "Collectivité"),
          _createElementVNode("h4", {
            class: "font-semibold",
            style: {"margin":"0"}
          }, "Modifier ma collectivité")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn lg white2",
          onClick: onCancel,
          disabled: loading.value
        }, "Annuler", 8, _hoisted_4),
        _createElementVNode("button", {
          type: "button",
          class: "btn lg",
          onClick: onSubmit,
          disabled: loading.value || pageLoading.value
        }, [
          (!loading.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Enregistrer"))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, "Enregistrement..."))
        ], 8, _hoisted_5)
      ])
    ]),
    (pageLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "edit-card-title" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-info-collectivite.svg",
                    class: "size-base",
                    alt: ""
                  }),
                  _createTextVNode(" Informations ")
                ], -1)),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.nom) = $event)),
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, formData.nom]
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("label", null, [
                    _createTextVNode("Désignation de la collectivité "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1))
                ]),
                (errors.nom)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(errors.nom), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-input",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.rccm) = $event)),
                        placeholder: ""
                      }, null, 512), [
                        [_vModelText, formData.rccm]
                      ]),
                      _cache[12] || (_cache[12] = _createElementVNode("label", null, [
                        _createTextVNode("Numéro du registre de commerce "),
                        _createElementVNode("b", { class: "color-danger" }, "*")
                      ], -1))
                    ]),
                    (errors.rccm)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(errors.rccm), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-input-select",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.pays_id) = $event))
                      }, [
                        _cache[13] || (_cache[13] = _createElementVNode("option", { value: null }, "Sélectionnez un pays", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupFormDatas.pays, (pays, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: pays.id,
                            key: 'pays_' + index
                          }, _toDisplayString(pays.nom), 9, _hoisted_20))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, formData.pays_id]
                      ]),
                      _cache[14] || (_cache[14] = _createElementVNode("label", null, [
                        _createTextVNode("Pays "),
                        _createElementVNode("b", { class: "color-danger" }, "*")
                      ], -1))
                    ]),
                    (errors.pays_id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(errors.pays_id), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.adresse) = $event)),
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, formData.adresse]
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("label", null, [
                    _createTextVNode("Adresse de l'entreprise "),
                    _createElementVNode("b", { class: "color-danger" }, "*")
                  ], -1))
                ]),
                (errors.adresse)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(errors.adresse), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", null, [
                    _createVNode(CustomPhoneInput, {
                      modelValue: formData.telephone,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.telephone) = $event)),
                      id: "telephone"
                    }, null, 8, ["modelValue"]),
                    (errors.telephone)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(errors.telephone), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        class: "form-input",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.email) = $event)),
                        placeholder: ""
                      }, null, 512), [
                        [_vModelText, formData.email]
                      ]),
                      _cache[16] || (_cache[16] = _createElementVNode("label", null, [
                        _createTextVNode("Adresse Email "),
                        _createElementVNode("b", { class: "color-danger" }, "*")
                      ], -1))
                    ]),
                    (errors.email)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(errors.email), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.date_creation) = $event))
                  }, null, 512), [
                    [_vModelText, formData.date_creation]
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("label", null, "Date de création", -1))
                ]),
                (errors.date_creation)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(errors.date_creation), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "edit-card-title" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-secteur-activite.svg",
                    class: "size-base",
                    alt: ""
                  }),
                  _createTextVNode(" Secteur d'activité ")
                ], -1)),
                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-sm text-grey-500 mt--2 mb-4" }, "Sélectionnez un ou plusieurs secteurs.", -1)),
                _createElementVNode("div", _hoisted_31, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(secteurs, (secteur) => {
                    return _createElementVNode("label", {
                      key: secteur.id,
                      class: _normalizeClass(["secteur-chip", { active: formData.secteurs.includes(secteur.value) }]),
                      for: `secteur_${secteur.id}`
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: `secteur_${secteur.id}`,
                        value: secteur.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.secteurs) = $event))
                      }, null, 8, _hoisted_33), [
                        [_vModelCheckbox, formData.secteurs]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(secteur.label), 1)
                    ], 10, _hoisted_32)
                  }), 64))
                ]),
                (errors.secteurs)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(errors.secteurs), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("aside", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "edit-card-title" }, [
                  _createElementVNode("img", {
                    src: "/public/icons/icon-info-collectivite.svg",
                    class: "size-base",
                    alt: ""
                  }),
                  _createTextVNode(" Logo ")
                ], -1)),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    (logoPreview.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: logoPreview.value,
                          alt: "Aperçu"
                        }, null, 8, _hoisted_39))
                      : (existingLogo.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: `${_unref(BACKEND_URL)}/assets/collectivites/${existingLogo.value}`,
                            alt: "Logo actuel"
                          }, null, 8, _hoisted_40))
                        : (_openBlock(), _createElementBlock("span", _hoisted_41, "Aucun logo"))
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("label", _hoisted_43, [
                      _cache[21] || (_cache[21] = _createElementVNode("img", {
                        src: "/public/icons/icon-upload.svg",
                        class: "btn-icon",
                        alt: ""
                      }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(existingLogo.value || logoFile.value ? 'Remplacer le logo' : 'Choisir un logo'), 1)
                    ]),
                    _createElementVNode("input", {
                      id: "logo-input",
                      type: "file",
                      accept: "image/*",
                      style: {"display":"none"},
                      onChange: onLogoSelected
                    }, null, 32),
                    (logoFile.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn white2",
                          onClick: clearLogo
                        }, " Annuler la sélection "))
                      : _createCommentVNode("", true)
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("p", {
                    class: "text-sm text-grey-500",
                    style: {"margin":"0"}
                  }, "PNG, JPG, SVG · max 5 Mo. Format carré recommandé.", -1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("button", {
              type: "button",
              class: "btn lg white2",
              onClick: onCancel,
              disabled: loading.value
            }, "Annuler", 8, _hoisted_45),
            _createElementVNode("button", {
              type: "button",
              class: "btn lg",
              onClick: onSubmit,
              disabled: loading.value
            }, [
              (!loading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Enregistrer les modifications"))
                : (_openBlock(), _createElementBlock("span", _hoisted_48, "Enregistrement..."))
            ], 8, _hoisted_46)
          ])
        ]))
  ]))
}
}

})